import { useHistory, useLocation, useParams } from "react-router-dom";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { formatDate } from "../../util/helper";
import { Card, Image, List } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { getExporterOfferProductsById } from "../../appRedux/actions";


const OfferProductViewExporter = () => {
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const dispatch = useDispatch();
  const location = useLocation();
  const isFromUserProfile = location.state?.isFromUserProfile;
  const { id } = useParams();

  const [fileName, setFileName] = useState("");

  const exporterOfferProduct = useSelector(
    (state) => state.exporterOfferProducts.productsDetailsById
  );

  useEffect(() => {
    if (id) {
      dispatch(getExporterOfferProductsById({ id }));
    }
  }, [id, dispatch]);

  useEffect(() => {
    const images = exporterOfferProduct?.primaryImage;
    if (Array.isArray(images)) {
      setFileName(images);
    } else if (typeof images === "string" && images) {
      setFileName([{ src: images }]);
    }
  }, [exporterOfferProduct]);

  const data = [
    {
      label: "Posted Date",
      value: formatDate(exporterOfferProduct?.createdAt),
    },
    {
      label: "Product Name",
      value: exporterOfferProduct?.name,
    },
    {
      label: "FOB/FOR Price",
      value: `${exporterOfferProduct?.currency} ${exporterOfferProduct?.price} / ${exporterOfferProduct?.uom}`,
    },
    // {
    //   label: "Inco Terms",  
    //   value: exporterOfferProduct?.paymentTerms,
    // },
    {
      label: "Payment Terms",
      value: exporterOfferProduct?.comments,
    },
  ];

  return (
    isValidElement(exporterOfferProduct) && (
      <Card className="myexim-detail-card">
        <div className="myexim-table-title">
          <div>
            <LeftOutlined
              style={{ fontSize: "20px", color: '#434E5B'}}
              size="large"
              onClick={() => {
                history.goBack();
              }}
            />
          </div>
          Offer Product Details
        </div>
        <div
          className={`logo-with-list gx-mt-4 ${
            isMobile ? "gx-flex-column" : ""
          }`}
        >
          <div style={{ paddingRight: 16 }}>
            {isValidString(exporterOfferProduct?.primaryImage) && (
              <div className={"logo-container"}>
                <div className={"logo-image"}>
                  <img
                    alt="..."
                    src={exporterOfferProduct?.primaryImage}
                    width={isMobile ? "100%" : 120}
                    height={isMobile ? "100%" : 120}
                  />
                </div>
              </div>
            )}
          </div>
          <div style={{ flex: 1 }}>
            <List
              itemLayout="horizontal"
              dataSource={data}
              renderItem={(item) =>
                item?.value && (
                  <List.Item className="myexim-details-list">
                    <List.Item.Meta
                      title={<div>{item.label}</div>}
                      description={isValidString(item.value) ? item.value : "-"}
                    />
                  </List.Item>
                )
              }
            />
            {fileName?.length > 0 && (
              <div className="attachments gx-mt-3">
                <div className="sub-header ">Attachments</div>
                <div className="gx-mt-4">
                  Please find the below attachment as a reference
                </div>
                <div className="gx-pt-4">
                  {fileName?.map((file, index) => (
                    <div key={index} className="gx-pb-3">
                      <Image
                        className="gx-rounded-lg"
                        width={isMobile ? "100%" : 150}
                        height={isMobile ? "100%" : 150}
                        src={file?.src}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </Card>
    )
  );
};

export default OfferProductViewExporter;
